import { decodeWorkspaceFilePathSegment } from '@/lib/workspace-files-route';

export function workspaceFilesMediaHref(orgSlug: string): string {
  return `/${orgSlug}/files/media`;
}

export function isWorkspaceFilesMediaRoute(
  filePath: string[] | undefined
): boolean {
  return (
    filePath?.length === 1 &&
    decodeWorkspaceFilePathSegment(filePath[0] ?? '') === 'media'
  );
}
